<template>
    <div class="home">
        <div class="pc-bannerBox" @mouseenter="bannerEnter" @mouseleave="bannerLeave">
            <div class="bannerBox" v-for="(v, i) in bannerList" :key="i">
                <div class="img" v-show="i == bannerIndex" :style="{ backgroundImage: `url(${v.img})` }"></div>
                <!-- <img :src="v.img"  v-show="i == bannerIndex" alt="" /> -->
                <!-- <el-image :src="v.img" class="bannerImg" alt="" v-show="i == bannerIndex" @click.stop="toPage(v)" /> -->
            </div>
            <div class="dotBox">
                <div class="dots">
                    <div class="minDot" :class="{ actDot: i == bannerIndex }" v-for="(v, i) in bannerList" :key="i" @click="changeDot(i)"></div>
                </div>
            </div>
        </div>
        <div class="pc-ysBox" style="padding-bottom: 40px">
            <div class="ysTitle">我们的优势</div>
            <div class="ysList">
                <div class="leftYs">
                    <div class="minLeft" v-for="(v, i) in ysList" :key="i">
                        <div class="leftBox">
                            <div class="leftImg">
                                <img :src="v.img" alt="" />
                            </div>
                            <div class="right">
                                <div class="rightTitle">
                                    {{ v.title }}
                                </div>
                                <div class="bottomFull">
                                    {{ v.fullTitle }}
                                </div>
                            </div>
                        </div>
                        <div class="rightBox">
                            <div class="topRight">{{ v.num }}{{ v.dw }}</div>
                            <div class="bottomRight">{{ v.numTitle }}</div>
                        </div>
                    </div>
                </div>
                <div class="rightYs">
                    <video src="../../assets/video/showVideo.mp4" controls preload ref="myVideo" class="infoImg"></video>
                </div>
            </div>
        </div>
        <div class="pc-cpCenterBox">
            <div class="cpCenterTitle">产品中心</div>
            <div class="cpInfoBox">
                <div class="leftCpInfo" @click="toPage(cpList[cpIndex])">
                    <div class="leftOne">
                        <div class="stepImg">
                            <img :src="cpList[cpIndex].cpInfoImg" alt="" />
                        </div>
                        <!-- 查看更多 -->
                        <div class="btn cpMore">查看更多</div>
                    </div>
                    <div class="leftTwo">
                        <img :src="cpList[cpIndex].infoImg" alt="" />
                    </div>
                    <div class="cpBtn">
                        <img src="@/assets/image/common/cpBtn.png" alt="" />
                    </div>
                </div>
                <div class="rightCpInfo">
                    <div class="actCpBox" :style="{ top: cpIndex * 160 + 20 + 'px' }">
                        <img src="@/assets/image/common/actCp.png" alt="" />
                    </div>
                    <div class="minCp" v-for="(v, i) in cpList" :key="i" @mouseenter="mouseenter(i)" @mouseleave="mouseleave" @click="toPage(v)">
                        <img :src="v.img" alt="" style="width: 140px; height: 140px" />
                        <div class="cpTitle">
                            <div class="title" :class="{ act: i === cpIndex }">
                                {{ v.title }}
                            </div>
                            <div class="english">
                                {{ v.english }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 品牌列表 -->
        <div class="pc-ysBox">
            <div class="ysTitle">我们的案例</div>
            <div class="ppList">
                <div class="minPP" v-for="(v, i) in ppList" :key="i" @click="toTextInfo(v)">
                    <div class="logoBox">
                        <el-image :src="v.logo" fit="scale-down"></el-image>
                    </div>
                    <div class="ppName">{{ v.name }}</div>
                    <div class="actPP">
                        <div class="ppName">
                            {{ v.name }}
                        </div>
                        <div class="ppBtn">
                            <div class="btn" @click="toTextInfo(v)">立即查看</div>
                        </div>
                    </div>
                </div>
            </div>
            <honor />
        </div>
        <!-- 联系我们 -->
        <div class="pc-concatUs">
            <callUs />
        </div>
    </div>
</template>

<script>
import { getClientList } from '@/api/api';
import honor from '@/components/honor/honor.vue';
import callUs from '@/components/callUs/callUs.vue';
export default {
    components: { honor, callUs },
    data() {
        return {
            bannerIndex: 0,
            bannerList: [
                {
                    url: '/ecPlatform',
                    // img: require('../../assets/image/common/banner1.png'),
                    img: 'https://mall-1258032265.cos.ap-chengdu.myqcloud.com/gw/banner1.png',
                },
                {
                    url: '/copDetail',
                    // img: require('../../assets/image/common/copDetailBanner.png'),
                    img: 'https://mall-1258032265.cos.ap-chengdu.myqcloud.com/gw/copDetailBanner.png',
                },
                {
                    url: 'dzDetail',
                    // img: require('../../assets/image/dzDetail/dzBanner.png'),
                    img: 'https://mall-1258032265.cos.ap-chengdu.myqcloud.com/gw/dzBanner.png',
                },
            ],
            ysList: [
                {
                    title: '产业互联，智启未来',
                    fullTitle: '互联网+产业，创新赋能，共赢数智新时代',
                    num: '11',
                    dw: '年',
                    numTitle: '数智赋能经验',
                    img: require('../../assets/image/common/ys1.png'),
                },
                {
                    title: '好运营，不烧钱',
                    fullTitle: '深度运营，赋能电商，助力企业电商发展',
                    num: '30',
                    dw: '+',
                    numTitle: '运营项目',
                    img: require('../../assets/image/common/ys2.png'),
                },
                {
                    title: '智能引领，智慧电商',
                    fullTitle: '体验至上，采购无忧，更懂企业的智慧电商平台',
                    num: '100',
                    dw: '+',
                    numTitle: '平台建设',
                    img: require('../../assets/image/common/ys3.png'),
                },
            ],
            cpIndex: 1,
            cpList: [
                {
                    title: '数字化智慧电商',
                    english: 'Digital Smart E-commerce',
                    fuTitle: '以协同创新驱动效率变革，助力企业快速数智化转型，成就高绩效组织‌',
                    tagList: ['客户运营管理平台', '智慧呼叫中心', '销售业务管理平台'],
                    img: require('../../assets/image/common/cp1.png'),
                    infoImg: require('../../assets/image/common/cp1Gif.gif'),
                    cpInfoImg: require('../../assets/image/common/cpInfo1.png'),
                    url: '/ecPlatform',
                },
                {
                    title: 'COP协同运营平台',
                    english: 'COP(Collaborative Operation Platform)',
                    fuTitle: '以协同创新驱动效率变革，助力企业快速数智化转型，成就高绩效组织‌',
                    tagList: ['智慧电商平台B2B', '智慧电商平台S2B2B', '智慧电商平台B2C', '智慧电商平台S2B2C', '私域智慧控销平台', '私域智慧直播平台'],
                    img: require('../../assets/image/common/cp2.png'),
                    infoImg: require('../../assets/image/common/cp2Gif.gif'),
                    cpInfoImg: require('../../assets/image/common/cpInfo2.png'),
                    url: '/copDetail',
                },
                {
                    title: '电子档案平台',
                    english: 'First Camp Archive Platform',
                    fuTitle: '以协同创新驱动效率变革，助力企业快速数智化转型，成就高绩效组织‌',
                    tagList: ['客户首营资质交换平台', '企业电子档案管理', '电子发票管理'],
                    img: require('../../assets/image/common/cp3.png'),
                    infoImg: require('../../assets/image/common/cp3Gif.gif'),
                    cpInfoImg: require('../../assets/image/common/cpInfo3.png'),
                    url: '/dzDetail',
                },
            ],
            timer: null,
            ppList: [],
            bannerTimer: null,
            websocket: null,
        };
    },
    mounted() {
        this.setCpTimer();
        this.getClientList();
        this.setBannerTimer();
        // this.initWebSocket();
    },
    beforeDestroy() {
        this.clearCpTimer();
        this.clearBannerTimer();
    },
    methods: {
        initWebSocket() {
            let socketUrl = 'ws://im-api.scyoumo.com/wss';
            this.websocket = new WebSocket(socketUrl);
            this.websocket.onmessage = this.websocketOnMessage;
        },
        websocketOnMessage(e) {
            let data = JSON.parse(e.data);
            console.log(data);
        },
        bannerEnter() {
            this.clearBannerTimer();
        },
        bannerLeave() {
            this.setBannerTimer();
        },
        changeDot(i) {
            // this.clearBannerTimer();
            this.bannerIndex = i;
            // this.setBannerTimer();
        },
        toPage(row) {
            this.$router.push(row.url);
        },
        toTextInfo(row) {
            console.log(row);
            // this.$router.push('/alTestInfo?id=' + row.id);
            this.$router.push('/alList');
        },
        // 获取品牌专区
        async getClientList() {
            let result = await getClientList();
            if (result.status == 200) {
                let { path, data } = result.data;
                console.log(path);
                let ppList = [];
                data.map((v) => {
                    v.logo = 'http://gw-api.scyoumo.com/storage/' + v.logo;
                    ppList.push(v);
                });
                console.log(ppList);
                this.ppList = ppList.slice(0, 8);
            }
        },
        mouseenter(i) {
            this.clearCpTimer();
            this.cpIndex = i;
        },
        mouseleave() {
            this.setCpTimer();
        },
        setCpTimer() {
            this.timer = setInterval(() => {
                if (this.cpIndex + 1 == 3) {
                    this.cpIndex = 0;
                } else {
                    this.cpIndex++;
                }
            }, 5000);
        },
        setBannerTimer() {
            this.clearBannerTimer();
            this.bannerTimer = setInterval(() => {
                if (this.bannerIndex + 1 == 3) {
                    this.bannerIndex = 0;
                } else {
                    this.bannerIndex++;
                }
            }, 20000);
        },
        clearBannerTimer() {
            clearInterval(this.bannerTimer);
            this.bannerTimer = null;
        },
        clearCpTimer() {
            clearInterval(this.timer);
            this.timer = null;
        },
    },
};
</script>

<style lang="scss" scoped>
.home {
    width: 100%;
    background-color: #fff;

    .pc-bannerBox {
        // max-width: 1912px;
        // width: 100%;
        position: relative;
        cursor: pointer;
        height: 580px;
        .bannerBox {
            width: 100%;
            height: 100%;
            position: absolute;
            .img {
                height: 580px;
                background: no-repeat center;
                background-size: cover;
                width: 100%;
            }
        }
        .bannerImg {
            width: 100%;
            height: 100%;
        }

        .dotBox {
            max-width: 1912px;
            position: absolute;
            width: 200px;
            height: 40px;
            bottom: 5%;
            left: 50%;
            margin-left: -600px;
            width: 1200px;

            .dots {
                display: flex;
                justify-content: center;
                gap: 8px;

                .minDot {
                    width: 34px;
                    height: 8px;
                    background: #fff;
                    border-radius: 5px;
                    transition: width 0.3s;
                    cursor: pointer;
                    opacity: 0.4;
                }

                .actDot {
                    background-color: #fff;
                    opacity: 1;
                }
            }
        }
    }

    .pc-ysBox {
        width: 100%;
        // background-color: #fff;
        padding: 48px 0 0px 0;

        .ysTitle {
            height: 60px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 34px;
            color: #1a1a1a;
            font-weight: 800;
            margin-bottom: 30px;
        }

        .ppList {
            width: 1200px;
            height: 400px;
            margin: 0 auto;
            display: flex;
            gap: 20px;
            flex-wrap: wrap;

            .minPP:hover {
                border: 1px solid #1472ff;

                // .actPP {
                //     left: 0;
                // }
            }

            .minPP {
                width: 285px;
                height: 190px;
                background: #ffffff;
                border-radius: 8px;
                border: 1px solid #e1e1e1;
                box-sizing: border-box;
                display: flex;
                align-items: center;
                position: relative;
                padding: 20px;
                cursor: pointer;
                flex-direction: column;
                overflow: hidden;
                gap: 15px;

                .logoBox {
                    width: 245px;
                    height: 110px;

                    .el-image {
                        width: 100%;
                        height: 100%;
                    }
                }

                .ppName {
                    font-size: 18px;
                    color: #333333;
                }

                .actPP {
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    left: -100%;
                    top: 0;
                    background-color: #fff;
                    border-radius: 8px;
                    transition: all 0.3s;
                    display: flex;
                    flex-wrap: wrap;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    gap: 20px;

                    .ppName {
                        font-size: 18px;
                        color: #333333;
                        width: 100%;

                        text-align: center;
                    }

                    .ppBtn {
                        .btn {
                            width: 80px;
                            height: 32px;
                            border-radius: 2px;
                            border: 1px solid #1472ff;
                            font-size: 14px;
                            color: #1472ff;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            cursor: pointer;
                        }
                    }
                }
            }
        }

        .ysList {
            width: 1264px;
            display: flex;
            justify-content: center;
            gap: 20px;
            margin: 0 auto;
            margin-top: 24px;

            .leftYs {
                display: flex;
                gap: 20px;
                flex-direction: column;

                .minLeft {
                    display: flex;
                    align-items: center;
                    gap: 24px;

                    .leftBox:hover {
                        border: 1px solid #1472ff !important;

                        .leftImg {
                            background-color: #1472ff;
                        }

                        .right {
                            margin-left: 10px;
                        }
                    }

                    .leftBox {
                        transition: all 0.2s;
                        width: 526px;
                        height: 75px;
                        display: flex;
                        align-items: center;
                        border: 1px solid #b4d2ff;
                        box-sizing: border-box;
                        gap: 20px;
                        cursor: pointer;

                        .leftImg {
                            width: 73px;
                            height: 73px;
                            background-color: #b4d2ff;
                            display: flex;
                            align-items: center;
                            justify-content: center;

                            img {
                                width: 46px;
                                height: 46px;
                            }
                        }

                        .right {
                            flex: 1;
                            display: flex;
                            flex-direction: column;
                            gap: 3px;

                            .rightTitle {
                                font-size: 20px;
                                color: #1472ff;
                                font-weight: bold;
                            }

                            .bottomFull {
                                font-size: 14px;
                                color: #595959;
                            }
                        }
                    }

                    .rightBox {
                        .topRight {
                            font-size: 20px;
                            color: #ffae32;
                            font-weight: bold;
                        }

                        .bottomRight {
                            font-size: 16px;
                            color: #333;
                        }
                    }
                }
            }

            .rightYs {
                width: 472px;
                height: 265px;
                background-color: #000;

                .infoImg {
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }

    .pc-cpCenterBox {
        width: 100%;
        height: 700px;
        background: url(../../assets/image/common/cpCenterBg.png) no-repeat center;
        background-size: 100% 100%;
        box-sizing: border-box;
        padding-top: 53px;

        .cpCenterTitle {
            display: flex;
            height: 40px;
            align-items: center;
            justify-content: center;
            font-size: 34px;
            font-weight: bold;
        }

        .cpInfoBox {
            width: 1264px;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 28px;
            margin: 0 auto;
            margin-top: 30px;

            .leftCpInfo {
                width: 700px;
                height: 520px;
                background: #ffffff;
                border-radius: 14px;
                padding: 20px 10px;
                box-sizing: border-box;
                display: flex;
                justify-content: space-between;
                position: relative;
                cursor: pointer;

                .leftOne {
                    width: 292px;
                    position: relative;

                    .cpMore:hover {
                        background-color: #1472ff;
                        color: #fff;
                    }

                    .cpMore {
                        position: absolute;
                        bottom: 10px;
                        right: 80px;
                        border: 1px solid #1472ff;
                        font-size: 14px;
                        color: #1472ff;
                        width: 80px;
                        height: 32px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        border-radius: 2px;
                    }

                    .stepImg {
                        img {
                            width: 330px;
                            margin-top: 50px;
                        }
                    }

                    .stepTitle {
                        font-size: 26px;
                        font-weight: bold;
                        margin-top: 34px;
                    }

                    .stepFuTitle {
                        margin-top: 8px;
                        font-size: 12px;
                        color: #666;
                    }

                    .stepTagBox {
                        margin-top: 40px;
                        display: flex;
                        flex-wrap: wrap;
                        width: 360px;

                        .w50 {
                            width: 50% !important;
                        }

                        .minTag {
                            width: 100%;
                            flex-shrink: 0;
                            font-size: 16px;
                            height: 22px;
                            display: flex;
                            align-items: center;
                            gap: 7px;
                            color: #343434;
                            margin-top: 20px;

                            span {
                                display: inline-block;
                                width: 8px;
                                height: 8px;
                                background-color: #dbdbdb;
                                border-radius: 50%;
                            }
                        }
                    }
                }

                .leftTwo {
                    width: 320px;
                    height: 500px;
                    display: flex;
                    align-items: center;

                    img {
                        width: 100%;
                        height: 320px;
                    }
                }

                .cpBtn {
                    position: absolute;
                    left: 0;
                    bottom: 0;
                }
            }

            .rightCpInfo {
                width: 472px;
                height: 520px;
                background: #ffffff;
                border-radius: 14px;
                display: flex;
                flex-direction: column;
                box-sizing: border-box;
                padding: 20px;
                position: relative;
                z-index: 10;

                .actCpBox {
                    width: 20px;
                    height: 160px;
                    position: absolute;
                    left: 0;
                    display: flex;
                    align-items: center;
                    transition: all 0.3s;

                    img {
                        width: 20px;
                        height: 46px;
                    }
                }

                .minCp {
                    height: 160px;
                    padding: 10px 0;
                    box-sizing: border-box;
                    display: flex;
                    padding-left: 46px;
                    display: flex;
                    gap: 38px;
                    align-items: center;
                    cursor: pointer;

                    .cpTitle {
                        .title {
                            font-size: 20px;
                            font-weight: bold;
                        }

                        .english {
                            font-size: 12px;
                            color: #b3b3b3;
                        }
                    }
                }
            }
        }
    }
}
</style>
